import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// action
import {
  registerUser,
  apiError,
  registerUserFailed,
  registerUserSuccessful,
} from "../../store/actions";

// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// import images
import logo from "../../assets/images/ezyfind-logo-dark.png";
import logolight from "../../assets/images/ezyfindlogo-light.png";
import { useMutation } from "@apollo/react-hooks";
import { REGISTER_USER } from "../../services/graphql";

const Register = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(false);

  const [
    onRegisterUser,
    { loading: createLoading, data: createdUserData, error: createUserError },
  ] = useMutation(REGISTER_USER);

  const registerUserSuccessful = (data) => {
    if (data.success === true) {
      props.registerUser(data.result, props.history);
    } else {
      props.apiError(createdUserData.registerUser.message, props.history);
    }
  };

  useEffect(() => {
    if (createLoading) {
      setLoading(true);
    }
    if (createdUserData && createdUserData.registerUser) {
      registerUserSuccessful(createdUserData.registerUser);
    }
    if (createUserError) {
      apiError(createUserError, props.history);
    }
  }, [createLoading, createdUserData, createUserError]);
  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    onRegisterUser({
      variables: {
        userDto: {
          fBAccessCode: "",
          facebookUserID: "",
          googleUserID: "123456789",
          linkedInUserID: "",
          twitterUserId: "",
          instagramUserID: "",
          email: "test50@ezyfind.co.za",
          contactNo: "724889910",
          userName: "test50@ezyfind.co.za",
          firstName: "John",
          lastName: "Pack",
          password: "122365",
          track: 4,
          domainUrl: "1",
          deviceID:
            "aa96537f9746bb98368e691bedf781879ac98511523ca19ef432e314eb19fbcb",
          deviceType: 1,
          provinceID: 1,
          provinceName: "",
          cityID: 1,
          cityName: "",
          suburbID: 1,
          suburbName: "",
          longitude: "",
          latitude: "",
          zipCode: "",
        },
        platform: 1,
      },
    });
    props.registerUser(values);
  };

  useEffect(() => {
    props.apiError("");
    document.body.className = "authentication-bg";
    // remove classname when component will unmount
    return function cleanup() {
      document.body.className = "";
    };
  });

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="mdi mdi-home-variant h2"></i>
        </Link>
      </div>
      <div className="account-pages my-1 pt-sm-5">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center">
                <Link to="/" className="mb-5 d-block auth-logo">
                  <img
                    src={logo}
                    alt=""
                    height="70"
                    width="250"
                    className="logo logo-dark"
                  />
                  <img
                    src={logolight}
                    alt=""
                    height="70"
                    width="250"
                    className="logo logo-light"
                  />
                </Link>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Register Account</h5>
                    <p className="text-muted">
                      Get your free EzyFind account now.
                    </p>
                  </div>
                  <div className="p-2 mt-4">
                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v);
                      }}
                    >
                      {props.user && props.user ? (
                        <Alert color="success">
                          Register User Successfully
                        </Alert>
                      ) : null}

                      {props.registrationError && props.registrationError ? (
                        <Alert color="danger">{props.registrationError}</Alert>
                      ) : null}

                      <div className="mb-3">
                        <AvField
                          id="email"
                          name="email"
                          label="Email"
                          onChange={(e) => setEmail(e.target.value)}
                          value={email}
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <AvField
                          name="username"
                          label="Username"
                          onChange={(e) => setUserName(e.target.value)}
                          value={userName}
                          type="text"
                          required
                          placeholder="Enter username"
                        />
                      </div>
                      <div className="mb-3">
                        <AvField
                          name="password"
                          label="Password"
                          type="password"
                          onChange={(e) => setPassword(e.target.value)}
                          value={password}
                          required
                          placeholder="Enter Password"
                        />
                      </div>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="auth-terms-condition-check"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="auth-terms-condition-check"
                        >
                          I accept{" "}
                          <Link to="#" className="text-dark">
                            Terms and Conditions
                          </Link>
                        </label>
                      </div>

                      <div className="mt-3 text-end">
                        <button
                          className="btn btn-primary w-sm waves-effect waves-light"
                          type="submit"
                        >
                          Register
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <div className="signin-other-title">
                          <h5 className="font-size-14 mb-3 title">
                            Sign up using
                          </h5>
                        </div>

                        <ul className="list-inline">
                          <li className="list-inline-item">
                            <Link
                              to="#"
                              className="social-list-item bg-primary text-white border-primary"
                            >
                              <i className="mdi mdi-facebook" />
                            </Link>
                          </li>{" "}
                          <li className="list-inline-item">
                            <Link
                              to="#"
                              className="social-list-item bg-info text-white border-info"
                            >
                              <i className="mdi mdi-twitter" />
                            </Link>
                          </li>{" "}
                          <li className="list-inline-item">
                            <Link
                              to="#"
                              className="social-list-item bg-danger text-white border-danger"
                            >
                              <i className="mdi mdi-google" />
                            </Link>
                          </li>
                        </ul>
                      </div>

                      <div className="mt-4 text-center">
                        <p className="text-muted mb-0">
                          Already have an account ?{" "}
                          <Link to="/login" className="fw-medium text-primary">
                            {" "}
                            Login
                          </Link>
                        </p>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} EzyFind. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger"></i> by Innovation Evolved Pty Ltd
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Register.propTypes = {
  registerUser: PropTypes.func,
  registerUserFailed: PropTypes.func,
  registrationError: PropTypes.any,
  user: PropTypes.any,
};

const mapStatetoProps = (state) => {
  const { user, registrationError, loading } = state.Account;
  return { user, registrationError, loading };
};

export default connect(mapStatetoProps, {
  registerUser,
  apiError,
  registerUserFailed,
})(Register);
